const sliderElements = document.querySelectorAll('.slider');

class Slider {
	constructor(element) {
		this.element = element;
		this.slides = this.element.querySelectorAll('.slider__slide');
		this.slideWrapper = this.element.querySelector('.slider__slides');
		this.prev = this.element.querySelector('.controls__button--prev');
		this.next = this.element.querySelector('.controls__button--next');
		this.activeIndex = 0;
		this.activeSlide = this.slides[this.activeIndex];
		this.autoHeight = false;
		this.init();
	}

	init() {
		this.addEventListeners();
		// If element has class of 'slider--auto-height', set autoHeight to true
		if (this.element.classList.contains('slider--auto-height')) {
			this.autoHeight = true;
		}
		// Once the page is loaded, set the height of the slider
		document.addEventListener('DOMContentLoaded', () => {
			setTimeout(() => {
				if (this.autoHeight && window.innerWidth > 1024) {
					this.setSliderHeight();
				} else {
					this.slideWrapper.style.height = `${445}px`;
				}
			}, 500);
		});

		window.addEventListener('resize', () => {
			if (this.autoHeight && window.innerWidth > 1024) {
				this.setSliderHeight();
			} else {
				this.slideWrapper.style.height = `${445}px`;
			}
		});
	}

	setSliderHeight() {
		// Get the parent element .panel-grid-cell
		const parent = this.element.closest('.panel-grid-cell');
		// Set the height of the wrapper to the height of the parent element
		this.slideWrapper.style.height = `${parent.clientHeight}px`;
	}

	addEventListeners() {
		this.prev.addEventListener('click', () => this.toggleSlide(++this.activeIndex));
		this.next.addEventListener('click', () => this.toggleSlide(--this.activeIndex));

		// Add touch event listeners for swiping left and right
		let touchStartX = 0;
		let touchEndX = 0;
		const swipeThreshold = 50; // Minimum swipe distance in pixels
		this.element.addEventListener('touchstart', e => {
			touchStartX = e.touches[0].clientX;
		});
		this.element.addEventListener('touchend', e => {
			touchEndX = e.changedTouches[0].clientX;
			const swipeDistance = touchEndX - touchStartX;
			if (swipeDistance < -swipeThreshold) {
				// Swiped left
				this.toggleSlide(++this.activeIndex);
			} else if (swipeDistance > swipeThreshold) {
				// Swiped right
				this.toggleSlide(--this.activeIndex);
			}
		});
	}

	toggleSlide(index) {
		this.activeIndex = index;
		if (this.activeIndex < 0) {
			this.activeIndex = this.slides.length - 1;
		}
		if (this.activeIndex >= this.slides.length) {
			this.activeIndex = 0;
		}
		this.activeSlide.classList.remove('slider__slide--active');
		this.activeSlide = this.slides[this.activeIndex];
		this.activeSlide.classList.add('slider__slide--active');
	}
}

sliderElements.forEach(slider => new Slider(slider));
